import React, { useState, useEffect } from "react"
import { NavLink } from "react-router-dom"
import Modal from "./AchiModal"
import { achievement } from "../../portfolio.js"
import Header from "../Header/Header"
function Achievement() {
  const [val, setval] = useState(achievement.achievement_data[0])
  const [idx, setidx] = useState(1)
  const [model, setModel] = useState(false)
  useEffect(() => {
    const interval = setInterval(() => {
      setidx((idx) => (idx + 1) % 4)
      setval(achievement.achievement_data[idx])
    }, 5000)
    return () => clearInterval(interval)
  }, [idx])

  const getData = (data) => {
    return setModel(true)
  }

  return (
    <div>
      <Header title="Achievements" />
      <div className="d-flex align-items-center">
        <div className="container-fluid ">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 mx-auto">
              <div className="row">
                <NavLink
                  to="/achievement"
                  style={{
                    width: "100px",
                    margin: "0% auto",
                    textAlign: "center",
                  }}
                  className="btn-get-started main-color"
                  onClick={() => getData(achievement.achievement_data)}
                >
                  More
                </NavLink>

                <div>
                  <h3 className="achi_div f_color text-center ">{val}</h3>
                </div>

                <div className="col-md-12">
                  <div ClassName="mycanvas" style={{ height: "69.44vh" }}>
                    <div className="container">
                      <div className="ball"></div>
                    </div>
                    <div className="shadow"></div>
                  </div>
                </div>
                <div className="mt-3"></div>
              </div>

              <div className="col-lg-6 order-1 order-lg-2 header-img"></div>
            </div>
          </div>
        </div>
      </div>
      {model === true ? (
        <Modal
          achidata={achievement.achievement_data}
          hide={() => setModel(false)}
        />
      ) : (
        ""
      )}
    </div>
  )
}

export default Achievement
